import SimpleSlotView from 'assembly/views/SimpleSlotView';

class GoldenGateSlotView extends SimpleSlotView {}

export default GoldenGateSlotView;
